module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "centerdiv"
  }, [_c('h2', [_vm._v("辅助功能")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 6
    }
  }, [_vm._v("从多少号开始（含此大题）")]), _vm._v(" "), _c('el-col', {
    staticClass: "lableft",
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.startMain),
      callback: function($$v) {
        _vm.startMain = $$v
      },
      expression: "startMain"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "textleft",
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addProblemMain
    }
  }, [_vm._v("增加大题号")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "lableft",
    attrs: {
      "span": 6
    }
  }, [_vm._v("初始化用户到第一题，用户GUID")]), _vm._v(" "), _c('el-col', {
    staticClass: "lableft",
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.startMain),
      callback: function($$v) {
        _vm.startMain = $$v
      },
      expression: "startMain"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "lableft",
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.initUser
    }
  }, [_vm._v("初始化")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 9
    }
  }, [_vm._v("参考网址：")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 22
    }
  }, [_vm._v("katex公式网址：https://khan.github.io/KaTeX/docs/supported.html")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 22
    }
  }, [_vm._v("内部链接写法：#/answer?title=知识点&guid=...")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 22
    }
  }, [_vm._v("内部pdf链接写法：#/pdf?title=1000个数学难题&url=...")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 22
    }
  }, [_vm._v("外部链接写法：#/outPage?title=欧拉&url=https://baike.baidu.com/...")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 22
    }
  }, [_vm._v("数学绘图网站：www.geogebra.org")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 22
    }
  }, [_vm._v("数学公式生成透明图：http://www.codecogs.com/latex/eqneditor.php")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 22
    }
  }, [_vm._v("查看关卡地内容地址：localhost:8080/#/level?level=2")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 22
    }
  }, [_vm._v("压缩图片网址：https://tinypng.com/ --png用它；https://squoosh.app/  --jpg用它")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 22
    }
  }, [_vm._v("跳转到用户主页：#/userInfo/d6c0a240bd4211e89076535ee3dd7eaf")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 22
    }
  }, [_vm._v("mathWeb中题目访问方法：mathmarch.com/problem/9a8414e016e311f08fa3abd5fe2eb099")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 22
    }
  }, [_vm._v("mathWeb中知识点访问方法：mathmarch.com/knowledge/96fce2203b4d11ee83fff95b5f929ea9")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 22
    }
  }, [_vm._v("题目中加入动画的方法：@@交互演示@@，然后加上阿里OSS下的链接，如：\nhttps://longmathimg.oss-cn-shanghai.aliyuncs.com/animate/assets/12k_pid_6.js，然后在 animateJSNames中输入JS名12k_pid_6，如果有多个，全输入并用逗号分隔。")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b6641fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/managerPage.vue
// module id = 635
// module chunks = 10